export default __webpack_public_path__ + "static/media/Telegram.1f65036c.svg";